import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './Column.scss'

const Column = ({ width, children, center, notPadded, introImage }) => {
	const columnClass = width => {
		return width ? 'column-' + width : 'column'
	}

	const centerClass = center ? styles.center : ''
	const notPaddedClass = notPadded ? styles.notPadded : ''
	const introImageClass = introImage ? styles.introImage : ''

	return (
		<div
			styleName={columnClass(width)}
			className={[centerClass, notPaddedClass, introImageClass].join(' ')}
		>
			{children}
		</div>
	)
}

Column.propTypes = {
	children: React.PropTypes.node,
	width: React.PropTypes.number
}

export default CSSModules(Column, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/Column.js